import { Navigate, Route, Routes } from "react-router-dom";
import { useAuthStore } from "@/stores/auth";
import { Login } from "@/pages/Login";
import { Chat } from "@/pages/Chat";
import { AdminTenants } from "@/pages/AdminTenants";
import { TenantUsers } from "@/pages/TenantUsers";
import { TenantRooms } from "@/pages/TenantRooms";
import { Layout } from "@/components/Layout";

function ProtectedRoute({ children, roles }: { children: React.ReactNode; roles?: string[] }) {
  const { accessToken, me } = useAuthStore();
  if (!accessToken) return <Navigate to="/login" replace />;
  if (roles && me && !roles.includes(me.role)) {
    // Redirigir al home apropiado según rol.
    const home = me.role === "superadmin" ? "/admin/tenants" : "/chat";
    return <Navigate to={home} replace />;
  }
  return <>{children}</>;
}

function HomeRedirect() {
  const me = useAuthStore((s) => s.me);
  if (!me) return <div className="flex h-full items-center justify-center text-slate-500">Cargando…</div>;
  const home = me.role === "superadmin" ? "/admin/tenants" : "/chat";
  return <Navigate to={home} replace />;
}

export function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<HomeRedirect />} />
        <Route
          path="chat"
          element={
            <ProtectedRoute roles={["tenant_admin", "agent", "customer"]}>
              <Chat />
            </ProtectedRoute>
          }
        />
        <Route
          path="chat/:roomId"
          element={
            <ProtectedRoute roles={["tenant_admin", "agent", "customer"]}>
              <Chat />
            </ProtectedRoute>
          }
        />
        <Route
          path="admin/tenants"
          element={
            <ProtectedRoute roles={["superadmin"]}>
              <AdminTenants />
            </ProtectedRoute>
          }
        />
        <Route
          path="tenant/users"
          element={
            <ProtectedRoute roles={["tenant_admin", "superadmin"]}>
              <TenantUsers />
            </ProtectedRoute>
          }
        />
        <Route
          path="tenant/rooms"
          element={
            <ProtectedRoute roles={["tenant_admin", "superadmin"]}>
              <TenantRooms />
            </ProtectedRoute>
          }
        />
      </Route>
      <Route path="*" element={<Navigate to="/chat" replace />} />
    </Routes>
  );
}
